import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import Vue from 'vue';
//import Vuetify from 'vuetify/lib';
import Vuetify from 'vuetify'; // the whole lot (not using alacarte)

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#97cb52',//'#8cc63e',
        secondary: '#939597',
        accent: '#4caf50',
        error: '#f44336',
        warning: '#ffeb3b',
        info: '#2196f3',
        success: '#cddc39',
      },
        /*
      light:{
            primary: '#8bc34a',
            secondary: '#607d8b',
            accent: '#cddc39',
            error: '#f44336',
            warning: '#ff9800',
            info: '#2196f3',
            success: '#4caf50'
      }
      */
    },
  },
});
